export default "__VITE_ASSET__Dg7rEcLK__"